import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/UI/Button/Button';
import authUtils from '@/helpers/authUtils';
import useAppLanguage from '@/hooks/useAppLanguage';
import useAuth from '@/hooks/useAuth';
import useGlobalSpinnerContext from '@/hooks/useGlobalSpinner';
import titleService from '@/services/titleService';
import styles from './DeniedPage.module.scss';

const DeniedPage = () => {
  const { t } = useTranslation();
  const lang = useAppLanguage();
  const authService = useAuth();
  const { setLoading } = useGlobalSpinnerContext();

  useEffect(() => {
    titleService.updatePageTitle(t('deniedPage.accessDenied'));
    setLoading(false);
  }, [t, lang]);

  const requestAcess = () => window.open(authUtils.registerUrl, '_blank');

  return (
    <>
      <div className={styles.DeniedPage}>
        <section className={styles.Content}>
          <section className={styles.Block}>
            <span className={styles.Title}>{t('deniedPage.accessDenied')}</span>
            <span className={styles.Info}><p>{t('deniedPage.generalInfo')}</p></span>
            <div className={styles.ButtonLine}>
              <Button id="btn-denied-page-request-access" buttonStyle="Primary" btnText={t('deniedPage.requestAcess')} handleClick={requestAcess} />
            </div>
            <section className={styles.Info}>
              <span id="btn-denied-page-logout" className={styles.Logout} onClick={() => authService.logout()} rel="noreferrer">{t('logout')}</span>
            </section>
          </section>
        </section>
      </div>
    </>
  );
};

export default DeniedPage;
